import { useEffect } from "react";
import HeaderBackButton from "../Header/HeaderBackButton";
import { useHeader } from "../Header/HeaderProvider";
import React from "react";
interface PageTitleProps {
  title: string;
}

const PageTitle = ({ title }: PageTitleProps) => {
  const { setTitle: setHeaderTitle, setHeaderLeft, setHeaderRight } = useHeader();
  useEffect(() => {
    setHeaderTitle(title);
    setHeaderLeft(<HeaderBackButton title={title} />);
    setHeaderRight(undefined);
  }, [setHeaderLeft, setHeaderRight, setHeaderTitle, title]);
  return null;
};
export default PageTitle;
